import { GlobalConfig } from 'ngx-toastr';
import { PremiitToastComponent } from '../shared/components/premiit-toast/premiit-toast.component';

export const TOAST_OPTIONS: Partial<GlobalConfig> = {
  positionClass: 'toast-top-center',
  timeOut: 3500,
  progressBar: false,
  tapToDismiss: true,
};
